import latin from "./latin";

export function translate(key) {
  if (Object.prototype.hasOwnProperty.call(latin, key)) return latin[key];
  return key;
}

export function format(template, params = {}) {
  return template.replace(/\{(\w+)\}/g, (_, k) => (k in params ? String(params[k]) : `{${k}}`));
}
